module.exports = __webpack_public_path__ + "assets/path-66933a668c5ccbe9875cd19cf0f32989.svg";